export default __webpack_public_path__ + "static/media/loginBg.079104f6.jpg";